import { Navigate, useLocation } from "react-router"
import type { ReactNode } from "react"
import { useAuth } from "./AuthProvider.js"
import { Spinner } from "../components/ui/Spinner.js"

/**
 * Client-side route guard (FRONTEND_REFERENCE.md section 2: "ya no hay
 * middleware.ts de Next, la protección de rutas pasa a ser un guard en el
 * cliente"). While the initial /auth/me check is in flight, renders a
 * loading state instead of flashing the login page then redirecting.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth()
  const location = useLocation()

  if (status === "loading") {
    return (
      <div style={{ display: "grid", placeItems: "center", height: "100vh" }}>
        <Spinner size="lg" />
      </div>
    )
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <>{children}</>
}

/** Extra gate for /admin (FR section 8: exclusivo de host_owner). */
export function RequireHostOwner({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  if (user?.systemRole !== "host_owner") {
    return <Navigate to="/dashboard" replace />
  }
  return <>{children}</>
}
